import { useEffect, useRef } from 'react';
import { performanceStat } from './performanceStat';

const PerformanceCompt = (props) => {
  const { pageInTime, dataLoadState } = props;
  const hasRecorded = useRef(false);
  useEffect(() => {
    if (dataLoadState !== 0 && !hasRecorded.current) {
      // alert(Date.now() - pageInTime);
      performanceStat.firstRenderTime(Date.now() - pageInTime);
      hasRecorded.current = true;
    }
  }, [dataLoadState]);
  return null;
};

export { PerformanceCompt };
